import React, { Component } from 'react';
import { Switch, Route, Link, Redirect } from 'react-router-dom';

import Dashboard from './containers/dashboard.js';
import Report from './containers/report.js';
import Start from './containers/start';
import NotFound from './containers/notfound.js';
import Footer from './components/footer.js';

class App extends Component {
  render() {
    return (
      <div>
        <header className="header">
          <h1> <Link to='/'> Minnesota Nursing Informatics Leadership Inventory™ </Link> </h1>
        </header>
        <div className='container-fluid'>
          <Switch>
            <Route exact path='/dashboard' component={Dashboard}/>
            <Route exact path='/' component={Start}/>
            <Route exact path='/survey' component={() => window.location = 'http://localhost:3001/survey'}/>
            <Route exact path='/report' component={Report}/>
            <Route exact path='/404' component={NotFound}/>
            <Redirect from='/*' to='/404' component={NotFound}/>
          </Switch>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js